import React from 'react';
import { Dropdown } from 'semantic-ui-react';

import { PagoConFechaDeRegistro } from '../tipos';
import EliminarPagoCuota from './EliminarPagoCuota';

type EstadoCuota =
    | 'POR_PAGAR'
    | 'PAGADA'
    | 'ATRASADA'
    | 'ABONADA'
    | 'ABONADA_ATRASADA'
    | 'FUTURA_CUOTA';

interface Props {
    idPlanDePago: string;
    numeroDeCuota: number;
    pagos: Array<PagoConFechaDeRegistro> | undefined;
    estadoCuota: EstadoCuota;
    alEditarPago(): void;
}

const Acciones: React.FunctionComponent<Props> = props => {
    const { estadoCuota, pagos, idPlanDePago, alEditarPago, numeroDeCuota } = props;

    return (
        <Dropdown
            icon='ellipsis vertical'
            pointing='top right'
            disabled={
                estadoCuota === 'ATRASADA' ||
                estadoCuota === 'POR_PAGAR' ||
                estadoCuota === 'FUTURA_CUOTA'
            }
        >
            <Dropdown.Menu>
                <EliminarPagoCuota
                    numeroDeCuota={numeroDeCuota}
                    pagos={pagos!}
                    idPlanDePago={idPlanDePago}
                    alEditarPago={alEditarPago}
                />
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default Acciones;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Componentes/Acciones.tsx